import React from "react";
import SearchInput from "../../../common/SearchInputField";
import Button from "@mui/material/Button";
import { FormControl, Select, MenuItem } from "@mui/material";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import { PlusIcon } from "../../../../utils/index";
import { useNavigate } from "react-router-dom";

const visibilityOptions = ["All", "Internal", "Public"];

export default function ArticlesToolbar({
  searchQuery,
  setSearchQuery,
  visibility,
  setVisibility,
  onCreate,
  kbRole,
}) {
  const navigate = useNavigate();
  const selectStyle = {
    borderRadius: "8px",
    borderColor: '#D5DCE1',
    background: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
    fontSize: "14px",
    height: "40px",
    color: "#405261",
    mr: 1.5,
    '& .MuiSelect-select': { padding: '0px 16px', fontSize: 14, color: '#405261' },
    '& .MuiSelect-icon': { fontSize: 14, },
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', marginTop: 24, paddingLeft: '24px', paddingRight: '24px', marginBottom: '12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ width: 360, flex: '0 0 280px' }}>
          <SearchInput
            placeholder="Search filter by keywords or tags "
            value={searchQuery}
            className='SearchInputField-article'
            onChange={(e) => setSearchQuery(e.target.value)}
            noTitle
          />
        </div>
        <FormControl size="small" sx={{ ...selectStyle }}>
          <Select
            value={visibility || ''}
            onChange={(e) => setVisibility(e.target.value)}
            IconComponent={Dropdown}
            displayEmpty
            renderValue={(selected) => !selected ? <span style={{ color: '#405261', fontSize: '14px' }}>Visibility</span> : selected}
            sx={{
              height: '40px', width: '120px', "& .MuiSelect-icon": {
                right: "16px !important"
              },
            }}
            MenuProps={{
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' },
              PaperProps: {
                sx: {
                  width: '184px',
                  borderRadius: '8px',
                  border: '1px solid #D5DCE1',
                  color: '#405261',
                  background: '#FFF',
                  boxShadow: '0 15px 20px 0 rgba(6, 21, 34, 0.05)',
                  mt: '8px',

                  '& .MuiMenuItem-root': {
                    fontSize: '14px',
                    px: '15px',
                    '&:hover': { color: '#061522', borderRadius: '8px', background: '#F9FAFA' },
                    '&.Mui-selected': { color: '#061522', borderRadius: '8px', background: '#F9FAFA', backgroundColor: '#F9FAFA' },
                  }
                }
              }
            }}
          >
            {visibilityOptions.map((opt) => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Hide New Article button for viewers */}
      {kbRole !== 'viewer' && (
        <Button
          variant="contained"
          disableElevation
          onClick={() => navigate('/kb/article/new')}
          sx={{
            minWidth: '152px', height: '40px', borderRadius: '8px',
            background: '#148DFD', boxShadow: '0 1px 2px 0 rgba(6, 21, 34, 0.05)',
            textTransform: 'none',
            '&:hover': { background: '#0f79d8' },
            display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'Inter', fontSize: '14px', fontWeight: 500, lineHeight: '18px'
          }}
        >
          <PlusIcon />
          New Article
        </Button>
      )}
    </div>
  );
}
